<template>
  <div class="country-cards">
    <a-row :gutter="[20, 20]">
      <a-col
        v-for="country in countries"
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
        :xl="6"
        :key="country.cca2"
      >
        <router-link
          :to="{
            name: 'CountryDetail',
            params: { countryName: country.name.common },
          }"
        >
          <CountryCard :country="country" />
        </router-link>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import CountryCard from '@/components/countries/CountryCard.vue';
export default {
  props: {
    countries: {
      // type: Object,
      required: true,
    },
  },
  components: {
    CountryCard,
  },
};
</script>

<style lang="scss" scoped>
.country-cards {
  margin-top: 18px;
}
</style>
